
define('text!templates/spinner.html',[],function () { return '<div class="text-center full">\n    <div class="midalign helper"></div>\n    <div class="midalign">\n        <div id="spinner">\n            <i class="fa fa-5x fa-spin fa-pulse fa-spinner"></i>\n            <div id="message"></div>\n        </div>\n    </div>\n</div>';});

